module.exports = __webpack_public_path__ + "comment.02f6a98a.png";